import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './hooks/useAuth'
import { useState, useEffect } from 'react'
import { supabase } from './lib/supabase'
import Login from './pages/Login'
import Patients from './pages/Patients'
import Consultations from './pages/Consultations'
import Facturation from './pages/Facturation'
import Comptabilite from './pages/Comptabilite'
import Agenda from './pages/Agenda'
import Parametres from './pages/Parametres'
import Partenaires from './pages/Partenaires'
import ComptesRendus from './pages/ComptesRendus'
import RelevesBancaires from './pages/RelevesBancaires'
import RemiseBanque from './pages/RemiseBanque'
import './index.css'

const MOIS_FR = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre']

function ReleveRappel({ praticienId }) {
  const [afficher, setAfficher] = useState(false)
  const [moisManquant, setMoisManquant] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    if (!praticienId) return
    const now = new Date()
    // Afficher seulement à partir du 10 du mois
    if (now.getDate() < 10) return

    // Mois précédent
    const moisPrec = now.getMonth() === 0 ? 12 : now.getMonth()
    const anneePrec = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear()

    supabase.from('releves_bancaires')
      .select('id').eq('praticien_id', praticienId)
      .eq('mois', moisPrec).eq('annee', anneePrec)
      .then(({ data }) => {
        if (!data || data.length === 0) {
          setMoisManquant({ mois: moisPrec, annee: anneePrec })
          setAfficher(true)
        }
      })
  }, [praticienId])

  if (!afficher) return null

  return (
    <div style={{
      background: '#FFF8E1', borderBottom: '1px solid #F9A825',
      padding: '10px 24px', display: 'flex', alignItems: 'center', gap: 12
    }}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#F57F17" strokeWidth="1.5">
        <path d="M8 1l7 14H1L8 1z"/><path d="M8 6v4M8 11v1"/>
      </svg>
      <span style={{fontSize: 13, color: '#5D4037', flex: 1}}>
        Le relevé bancaire de <strong>{MOIS_FR[moisManquant.mois - 1]} {moisManquant.annee}</strong> n'a pas encore été uploadé.
      </span>
      <button
        onClick={() => { navigate('/releves'); setAfficher(false) }}
        style={{fontSize: 12, fontWeight: 600, color: '#E65100', background: 'none', border: '1px solid #E65100', borderRadius: 6, padding: '4px 12px', cursor: 'pointer'}}>
        Uploader maintenant
      </button>
      <button onClick={() => setAfficher(false)}
        style={{background: 'none', border: 'none', cursor: 'pointer', color: '#999', fontSize: 16, lineHeight: 1}}>
        ✕
      </button>
    </div>
  )
}

const NAV = [
  { path: '/agenda', label: 'Agenda', section: 'Principal',
    icon: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="3" width="12" height="11" rx="2"/><path d="M5 1v4M11 1v4M2 7h12"/></svg> },
  { path: '/patients', label: 'Patients', section: null,
    icon: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="8" cy="5" r="3"/><path d="M2 14c0-3.3 2.7-6 6-6s6 2.7 6 6"/></svg> },
  { path: '/consultations', label: 'Consultations', section: null,
    icon: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 4h10M3 8h7M3 12h5"/></svg> },
  { path: '/comptes-rendus', label: 'Comptes rendus', section: null,
    icon: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="1" width="12" height="14" rx="2"/><path d="M5 5h6M5 8h6M5 11h3"/></svg> },
  { path: '/facturation', label: 'Facturation', section: 'Finance',
    icon: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="1" width="12" height="14" rx="2"/><path d="M5 5h6M5 8h6M5 11h4"/></svg> },
  { path: '/remise-banque', label: 'Remise en banque', section: null,
    icon: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="1" y="4" width="14" height="9" rx="1.5"/><path d="M1 7h14M4 10h3"/></svg> },
  { path: '/comptabilite', label: 'Comptabilité', section: null,
    icon: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M2 12l4-4 3 3 5-6"/></svg> },
  { path: '/releves', label: 'Relevés bancaires', section: null,
    icon: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="2" width="12" height="12" rx="2"/><path d="M5 6h6M5 9h4"/></svg> },
  { path: '/releves?entite=cabinet_commun', label: 'Cabinet commun', section: null,
    icon: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M2 14V7l6-5 6 5v7"/><path d="M6 14v-4h4v4"/></svg> },
  { path: '/releves?entite=sci', label: 'SCI', section: null,
    icon: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="1" y="8" width="14" height="7" rx="1"/><path d="M4 8V5a4 4 0 018 0v3"/></svg> },
  { path: '/partenaires', label: 'Partenaires', section: 'Annuaire',
    icon: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="6" cy="5" r="2.5"/><circle cx="11" cy="5" r="2.5"/><path d="M1 14c0-2.8 2.2-5 5-5"/><path d="M8 14c0-2.8 2.2-5 5-5"/></svg> },
  { path: '/parametres', label: 'Paramètres', section: 'Compte',
    icon: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="8" cy="8" r="2.5"/><path d="M8 1v2M8 13v2M1 8h2M13 8h2M3.05 3.05l1.42 1.42M11.53 11.53l1.42 1.42M3.05 12.95l1.42-1.42M11.53 4.47l1.42-1.42"/></svg> },
]

const PAGE_TITLES = {
  '/agenda': 'Agenda',
  '/patients': 'Patients',
  '/consultations': 'Consultations',
  '/comptes-rendus': 'Comptes rendus',
  '/facturation': 'Facturation',
  '/remise-banque': 'Remise en banque',
  '/comptabilite': 'Comptabilité',
  '/partenaires': 'Praticiens partenaires',
  '/releves': 'Relevés bancaires',
  '/releves?entite=cabinet_commun': 'Cabinet commun',
  '/releves?entite=sci': 'SCI',
}

const PAGE_ACTIONS = {
  '/agenda': '+ Nouveau RDV',
  '/patients': '+ Nouveau patient',
  '/consultations': '+ Nouvelle consultation',
  '/comptes-rendus': '+ Nouveau compte rendu',
  '/facturation': '+ Nouvelle facture',
  '/comptabilite': '+ Nouvelle écriture',
  '/partenaires': '+ Nouveau partenaire',
  '/releves': '',
}

function Layout({ children }) {
  const { praticien, signOut } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()
  const isV2 = praticien?.nom?.charCodeAt(0) % 2 === 0

  function initiales() {
    return ((praticien?.prenom?.[0] || '') + (praticien?.nom?.[0] || '')).toUpperCase()
  }

  // Expose openPanel globally per page via custom event
  function handleAction() {
    window.dispatchEvent(new CustomEvent('cabinet:new'))
  }

  return (
    <div className="app">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <h2>Cabinet Ostéo</h2>
          <p>Gestion du cabinet</p>
        </div>
        <nav className="nav">
          {NAV.map((item, i) => {
            const showSection = item.section && (i === 0 || NAV[i-1].section !== item.section)
            return (
              <div key={item.path}>
                {showSection && <div className="nav-section">{item.section}</div>}
                <div
                  className={`nav-item ${(location.pathname + location.search) === item.path || (item.path === '/releves' && location.pathname === '/releves' && !location.search) ? 'active' : ''}`}
                  onClick={() => navigate(item.path)}
                >
                  {item.icon}
                  {item.label}
                </div>
              </div>
            )
          })}
        </nav>
        <div className="sidebar-user">
          <div style={{display:'flex', alignItems:'center', gap:10}}>
            <div className={`avatar ${isV2 ? 'v2' : ''}`} style={{flexShrink:0}}>{initiales()}</div>
            <div>
              <div className="name">{praticien?.prenom} {praticien?.nom}</div>
              <div className="role" style={{cursor:'pointer', textDecoration:'underline'}} onClick={signOut}>Déconnexion</div>
            </div>
          </div>
        </div>
      </aside>

      <div className="main">
        <ReleveRappel praticienId={praticien?.id} />
        <div className="topbar">
          <span className="topbar-title">{PAGE_TITLES[location.pathname]}</span>
          <div className="topbar-right">
            {PAGE_ACTIONS[location.pathname] && (
              <button
                onClick={handleAction}
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: 8,
                  padding: '9px 18px', borderRadius: 8,
                  background: 'linear-gradient(135deg, #1D9E75 0%, #158A63 100%)',
                  color: '#fff', border: 'none', fontSize: 13, fontWeight: 600,
                  cursor: 'pointer', boxShadow: '0 2px 8px rgba(29,158,117,.35)',
                  transition: 'transform .1s, box-shadow .1s',
                }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(29,158,117,.45)' }}
                onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 2px 8px rgba(29,158,117,.35)' }}
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round">
                  <path d="M7 1v12M1 7h12"/>
                </svg>
                {PAGE_ACTIONS[location.pathname].replace('+ ', '')}
              </button>
            )}
          </div>
        </div>
        <div className="content">
          {children}
        </div>
      </div>
    </div>
  )
}

function PrivateRoute({ children }) {
  const { user, praticien, loading } = useAuth()
  if (loading) return <div className="loading">Chargement…</div>
  if (!user) return <Navigate to="/login" replace />
  if (!praticien) return <div className="loading">Chargement du profil…</div>
  return <Layout>{children}</Layout>
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginGuard />} />
          <Route path="/agenda" element={<PrivateRoute><Agenda /></PrivateRoute>} />
          <Route path="/patients" element={<PrivateRoute><Patients /></PrivateRoute>} />
          <Route path="/consultations" element={<PrivateRoute><Consultations /></PrivateRoute>} />
          <Route path="/comptes-rendus" element={<PrivateRoute><ComptesRendus /></PrivateRoute>} />
          <Route path="/facturation" element={<PrivateRoute><Facturation /></PrivateRoute>} />
          <Route path="/remise-banque" element={<PrivateRoute><RemiseBanque /></PrivateRoute>} />
          <Route path="/comptabilite" element={<PrivateRoute><Comptabilite /></PrivateRoute>} />
          <Route path="/partenaires" element={<PrivateRoute><Partenaires /></PrivateRoute>} />
          <Route path="/releves" element={<PrivateRoute><RelevesBancaires /></PrivateRoute>} />
          <Route path="/parametres" element={<PrivateRoute><Parametres /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/agenda" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}

function LoginGuard() {
  const { user, loading } = useAuth()
  if (loading) return <div className="loading">Chargement…</div>
  if (user) return <Navigate to="/agenda" replace />
  return <Login />
}
